import { Observable } from 'rxjs/Observable';
import getEventSongs from '../actions/events/getEventSongsAction';

export function handleEditEventSongsFulfilled(action$, store) {
    return action$.filter(
        action => action.type === 'DELETE_EVENT_SONGS_FULFILLED' ||
            action.type === 'MARK_EVENT_SONGS_FULFILLED' ||
            action.type === 'MOVE_EVENT_SONGS_FULFILLED' ||
            action.type === 'ADD_EVENT_SONGS_FULFILLED' ||
            action.type === 'SET_EVENT_SPECIAL_SONG_IN_SECTION_FULFILLED' ||
            action.type === 'DELETE_EVENT_SPECIAL_SONG_FULFILLED')
        .mergeMap(() => Observable.merge(
            Observable.of(getEventSongs(store.getState().events.currentEvent.objectId)))
        );
}



// WEBPACK FOOTER //
// ./src/epics/editEventSongsEpic.js